import React from 'react';
import RecentlyTouched from '../../HomeScreen/RecentlyTouched';

const RecentActivityModule = () => <RecentlyTouched />;

export default RecentActivityModule;
